import type { FC } from 'react'
import Modal, { type ModalProps } from '@mui/material/Modal'
import { Link, type LinkProps } from '../../compass-ui'
import CloseButton from '../CloseButton'

export const ModalLink: FC<LinkProps> = ({ children, onClick, ...props }) => (
  <Link
    onClick={(e) => {
      e.preventDefault()
      if (onClick) onClick(e)
    }}
    {...props}
  >
    {children}
  </Link>
)

export interface BaseModalProps extends ModalProps {
  width?: number
}

const BaseModal: FC<BaseModalProps> = ({ children, width = 600, onClose, ...props }) => (
  <Modal onClose={onClose} {...props}>
    <div
      data-testid="base-modal"
      className={`
        absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
        w-full p-6 flex items-center overflow-y-scroll
        bg-ink-100 rounded-md
      `}
      style={{
        maxWidth: `${width}px`,
      }}
    >
      {onClose && <CloseButton onClose={onClose} />}
      {children}
    </div>
  </Modal>
)

export default BaseModal
